module.exports = __webpack_public_path__ + "img/t1-intro-text.00bbccf9.png";